/**
 * Progressive-reveal gates for `AboutYouStep`.
 *
 * Country-scoped specialties need the country known first, so the reveal is
 * Country → Role → Specialty. The country value is geo-seeded, so the three
 * fields typically reveal together once a name is entered — role/specialty
 * only wait when geo-detection failed and no country is set.
 */
export function useAboutYouSteps(params: { hasName: boolean; hasCountry: boolean }) {
  const { hasName, hasCountry } = params;
  const showLaterFields = hasName && hasCountry;

  return {
    showSpecialtyField: showLaterFields,
    showRoleField: showLaterFields,
    showCountryField: hasName,
  };
}
